import { render } from "./CIS-Blockquote-Blue-Box.vue?vue&type=template&id=22b979ba&scoped=true"
import script from "./CIS-Blockquote-Blue-Box.vue?vue&type=script&lang=js"
export * from "./CIS-Blockquote-Blue-Box.vue?vue&type=script&lang=js"

import "./CIS-Blockquote-Blue-Box.vue?vue&type=style&index=0&id=22b979ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b979ba"]])

export default __exports__